'use strict';

/**
 * Sends PayU success callback data to the backend
 * and redirects the user after successful processing.
 * @param {Object} response - PayU callback response object
 * @param {Object} paymentData - Scheme callback response object
 */
function updateSuccessPayUStatus(response, paymentData) {
    if (!response) {
        return;
    }

    var payload = {
        payUOrderID: response.mihpayid || '',
        status: response.status || '',
        hash: response.hash || '',
        txnid: response.txnid || '',
        email: response.email || '',
        firstname: response.firstname || '',
        productinfo: response.productinfo || '',
        amount: response.amount || '',
        error_code: response.error || '',
        key: response.key || ''
    };

    var formData = {
        payload: JSON.stringify(payload),
        paymentData: JSON.stringify(paymentData)
    };

    var url = $('.handlePayUSuccessCallbackURL').data('url');

    // Exit if URL is not available
    if (!url) {
        return;
    }

    $.ajax({
        url: url,
        type: 'POST',
        data: formData,
        success: function (res) {
            // Redirect user if redirect URL is returned
            if (res && res.redirectUrl) {
                window.location.assign(res.redirectUrl);
            }
            $.spinner().stop();
        },

        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Handles popup dismissal action and updates payment failure status.
 *
 * @param {Object} data - Payment response data
 * @param {string} dismissalUrl - Backend URL to handle dismissal request
 */
function callDismissalHandler(data, dismissalUrl) {
    if (!data || !dismissalUrl) {
        return;
    }

    var payload = {
        txnid: data.txnId || '',
        txnMessage: data.txnMessage,
        txnStatus: data.txnStatus
    };

    $.spinner().start();
    $.ajax({
        url: dismissalUrl,
        type: 'POST',
        data: payload,
        success: function (response) {
            $.spinner().stop();
            if (response.success) {
                $('#payuFailedModal').modal('show');
            }
        },
        error: function () {
            $.spinner().stop();
            $('.error-message').show();
        }
    });
}

module.exports = {
    callDismissalHandler: callDismissalHandler,
    updateSuccessPayUStatus: updateSuccessPayUStatus
};
